import React from 'react';
import './OnePrice.css';

const OnePrice = () => {
  const handleScrollToSecure = () => {
    const section = document.getElementById('contact-form');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="mc-section mc-one-price-section">
      <div className="mc-price-card">
        <h2 className="mc-price-title mc-gradient-accent">One Price, Everything Included</h2>

        <div className="mc-price-amount">₹ 5000</div>
        <div className="mc-price-label">Incl. GST</div>

        <div className="mc-price-checklist">
          <div className="mc-price-checkitem">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
            Full 3-Week Curriculum
          </div>
          <div className="mc-price-checkitem">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
            Lifetime Notes Access
          </div>
          {/* <div className="mc-price-checkitem">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
            Private Discord Community
          </div> */}
          <div className="mc-price-checkitem">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
            Verified Certificate
          </div>
        </div>

        <button className="mc-price-btn" onClick={handleScrollToSecure}>Secure Your Seat</button>
      </div>
    </section>
  );
};

export default OnePrice;
